<template>
  <div class="team-block">
    <vbLink :to="profileLink" class="team-block__avatar">
      <img v-if="avatar" :alt="team.name" :src="avatar">
      <DefaultAvatar v-else :initial="teamInitial" />
    </vbLink>
    <div>
      <vbLink :to="profileLink" class="team-block__name">
        {{ team.name }}
      </vbLink>
    </div>
  </div>
</template>

<script>
  import Team from '~/modules/teams/entities/frontend/team'
  import DefaultAvatar from '~/components/frontend/default-avatar'

  export default {
    name: 'TeamBlock',
    components: {
      DefaultAvatar,
    },
    props: {
      team: {
        type: Team,
        required: true,
      },
    },
    computed: {
      avatar () {
        const publicId = this.team.avatar.publicId

        if(publicId === null || publicId.includes('avatar_teams')) {
          return null
        }

        return this.$get(this.team, 'avatar.small', null)
      },
      profileLink () {
        return {
          name: 'teams:frontend:profile',
          params: {
            slug: this.$get(this.team, 'slug'),
          },
        }
      },
      teamInitial () {
        return this.team.name.charAt(0)
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "~foundation-sites/scss/util/_unit";

  .team-block {
    a {
      display: inline-block;

      &.team-block__name {
        margin-top: 0.5rem;
      }
    }
  }
</style>
